import {
  ACTIVATE_SELECT_ALL,
  ASSIGN_REQUEST_ASYNC,
  ASSIGNED_FILTER_CHANGE,
  COMPANIES_DATA_REQUEST_ASYNC,
  FILTERS_CHANGE,
  FILTERS_CLEAR,
  FILTERS_SUBMIT,
  PAGINATE_CHANGE,
  SEARCH_CHANGE,
  SEARCH_RESET,
  SELECT_TOGGLE,
  SORT_PROPERTY_CHANGE,
} from './constants'

const fetchCompaniesData = (name, id) => ({
  type: COMPANIES_DATA_REQUEST_ASYNC.INITIATE,
  payload: { name, id },
})
export const fetchCompaniesDataSuccess = (data) => ({
  type: COMPANIES_DATA_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchCompaniesDataError = (error) => ({
  type: COMPANIES_DATA_REQUEST_ASYNC.ERROR,
  error,
})
const fetchCompaniesDataCancel = () => ({
  type: COMPANIES_DATA_REQUEST_ASYNC.CANCEL,
})

const assignToCompanies = () => ({ type: ASSIGN_REQUEST_ASYNC.INITIATE })
export const assignToCompaniesSuccess = (data) => ({
  type: ASSIGN_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const assignToCompaniesError = (error) => ({
  type: ASSIGN_REQUEST_ASYNC.ERROR,
  error,
})
const assignToCompaniesCancel = () => ({ type: ASSIGN_REQUEST_ASYNC.CANCEL })

export const filtersChange = (value, filterType) => ({
  type: FILTERS_CHANGE,
  payload: { value, filterType },
})
const filtersClear = () => ({ type: FILTERS_CLEAR })
const filtersSubmit = () => ({ type: FILTERS_SUBMIT })
const assignedFilterChange = (value) => ({
  type: ASSIGNED_FILTER_CHANGE,
  payload: { value },
})

const sortPropertyChange = (value) => ({
  type: SORT_PROPERTY_CHANGE,
  payload: { value },
})

const paginateChange = (page) => ({ type: PAGINATE_CHANGE, payload: { page } })

const searchChange = (q) => ({ type: SEARCH_CHANGE, payload: { q } })
const searchReset = () => ({ type: SEARCH_RESET })

const toggleSelect = (id) => ({ type: SELECT_TOGGLE, payload: { id } })
const activateSelectAll = () => ({ type: ACTIVATE_SELECT_ALL })

export default {
  // to props
  filtersChange,
  filtersClear,
  filtersSubmit,
  assignedFilterChange,
  fetchCompaniesData,
  fetchCompaniesDataCancel,
  assignToCompanies,
  assignToCompaniesCancel,
  sortPropertyChange,
  paginateChange,
  searchChange,
  searchReset,
  toggleSelect,
  activateSelectAll,
}
